import React, { useState, useRef, useEffect, useCallback } from 'react';
import './styles.scss';
import classnames from 'classnames';

const RangeSlider = ({
  title,
  prefix,
  min,
  max,
  minValue,
  maxValue,
  onChange,
}) => {
  const [minVal, setMinVal] = useState(minValue);
  const [maxVal, setMaxVal] = useState(maxValue);
  const minValRef = useRef(null);
  const maxValRef = useRef(null);
  const range = useRef(null);

  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );

  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(+maxValRef.current.value);

      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [minVal, getPercent]);

  useEffect(() => {
    if (minValRef.current) {
      const minPercent = getPercent(+minValRef.current.value);
      const maxPercent = getPercent(maxVal);

      if (range.current) {
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [maxVal, getPercent]);

  return (
    <div className="w-100 pb-4">
      <div className="mb-3 d-flex w-100 px-3 align-items-center justify-content-start text-dark">
        {title}
      </div>
      <div className="range-slider">
        <input
          type="range"
          min={min}
          max={max}
          value={minVal}
          ref={minValRef}
          onChange={(event) => {
            const value = Math.min(+event.target.value, maxVal - 1);
            setMinVal(value);
            event.target.value = value.toString();
            onChange({ minVal: value, maxVal });
          }}
          className={classnames('thumb thumb--zindex-3', {
            'thumb--zindex-5': minVal > max - 100,
          })}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={maxVal}
          ref={maxValRef}
          onChange={(event) => {
            const value = Math.max(+event.target.value, minVal + 1);
            setMaxVal(value);
            event.target.value = value.toString();
            onChange({ minVal, maxVal: value });
          }}
          className="thumb thumb--zindex-4"
        />

        <div className="slider">
          <div className="slider__track" />
          <div ref={range} className="slider__range" />
          <div className="slider__left-value text-light-gray">
            {minVal}
            <span className="currecny px-1 text-light\-gray">({prefix})</span>
          </div>
          <div className="slider__right-value text-light-gray">
            <span className="currecny px-1 text-light-gray">({prefix})</span>
            {maxVal}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
